module.exports = __webpack_public_path__ + "img/providers.d1bc1b51.svg";